import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtherLinksRoutingModule } from './other-links-routing.module';
import { TermsofuseComponent } from'./termsofuse/termsofuse.component';
import { SharedModule } from '../shared/shared.module'
import { PrivacypolicyComponent} from './privacypolicy/privacypolicy.component';
import { FaqComponent } from './faq/faq.component';

@NgModule({
  declarations: [TermsofuseComponent,PrivacypolicyComponent,FaqComponent],
  imports: [
    CommonModule,
    OtherLinksRoutingModule,
    SharedModule
  ]
})
export class OtherLinksModule { }
